export function formatReviewRating(rating: number): string {
  return rating.toFixed(2);
}
